import { useNavigate } from 'react-router-dom';
import { ChevronLeft, Wallet, Repeat, Moon, Settings, MoreHorizontal } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { LanguageToggle } from '@/components/LanguageToggle';
import { useLang } from '@/context/LanguageContext';
import { TEST_IDS } from '@/constants/testIds/app';

export const AppHeader = ({ title, subtitle, back = false, showMore = false }) => {
  const navigate = useNavigate();
  const { t } = useLang();
  return (
    <header className="flex items-start justify-between gap-3 pb-1 pt-2">
      <div className="flex min-w-0 items-center gap-2">
        {back ? (
          <button
            data-testid="app-back-button"
            onClick={() => navigate(-1)}
            className="flex h-9 w-9 items-center justify-center rounded-full bg-white/[0.06] text-foreground/80 transition-colors hover:bg-white/[0.1]"
          >
            <ChevronLeft className="h-5 w-5" />
          </button>
        ) : null}
        <div className="min-w-0">
          <h1 className="font-display text-xl font-semibold leading-tight tracking-tight text-foreground">
            {title}
          </h1>
          {subtitle ? <p className="truncate text-xs text-foreground/55">{subtitle}</p> : null}
        </div>
      </div>
      <div className="flex shrink-0 items-center gap-2">
        <LanguageToggle />
        {showMore ? (
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <button
                data-testid={TEST_IDS.dashboard.moreMenu}
                className="flex h-9 w-9 items-center justify-center rounded-full bg-white/[0.06] text-foreground/80 transition-colors hover:bg-white/[0.1]"
              >
                <MoreHorizontal className="h-5 w-5" />
              </button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="w-52 border-white/10 bg-[#0A1730] text-foreground">
              <DropdownMenuItem data-testid="more-finance" onClick={() => navigate('/finance')} className="gap-2">
                <Wallet className="h-4 w-4 text-brand-cyan" /> {t('more.finance')}
              </DropdownMenuItem>
              <DropdownMenuItem data-testid="more-habits" onClick={() => navigate('/habits')} className="gap-2">
                <Repeat className="h-4 w-4 text-brand-cyan" /> {t('more.habits')}
              </DropdownMenuItem>
              <DropdownMenuItem data-testid="more-review" onClick={() => navigate('/review')} className="gap-2">
                <Moon className="h-4 w-4 text-brand-cyan" /> {t('more.review')}
              </DropdownMenuItem>
              <DropdownMenuItem data-testid="more-settings" onClick={() => navigate('/settings')} className="gap-2">
                <Settings className="h-4 w-4 text-brand-cyan" /> {t('more.settings')}
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        ) : null}
      </div>
    </header>
  );
};
